import { Injectable, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SessionService } from '@innovation-os-ng/core/auth';
import { CustomProperties, TrackingService } from '@innovation-os-ng/core/core';
import { Tenant } from '@innovation-os-ng/core/models';
import { SpaceSelectors, TenantSelectors } from '@innovation-os-ng/core/state';
import { Store } from '@ngrx/store';
import { Subject, withLatestFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InsightsTrackingService implements OnDestroy {
  // private trackerCache: { tenant?: Promise<Tenant>; space?: string; user?: string } = {};
  private onDestroy: Subject<void> = new Subject<void>();
  private currentSpaceUri: string;
  private tenant: Tenant;
  constructor(
    private readonly trackingService: TrackingService,
    private readonly sessionService: SessionService,
    private readonly store: Store
  ) {
    this.store
      .select(SpaceSelectors.selectCurrentSpaceUri)
      .pipe(withLatestFrom(this.store.select(TenantSelectors.selectCurrentTenant)))
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: ([currentSpaceUri, tenant]) => {
          this.currentSpaceUri = currentSpaceUri;
          this.tenant = tenant;
        }
      });
  }

  /**
   * Track the given event, attaching necessary tenant/space/user params
   *
   * @param eventID EventID should match that in the relevant Analytics spreadsheet
   * @param customProperties Optional Object of extra params to send with the event
   */
  public trackEvent(eventID: string, customProperties?: CustomProperties) {
    console.assert(!!this.currentSpaceUri, 'currentSpaceUri should not be null');
    console.assert(!!this.tenant, 'tenant should not be null');
    this.trackingService.trackEvent(this.tenant, this.currentSpaceUri, this.sessionService.getUser().sub, eventID, null, null, null, customProperties);
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
